import PagingIndicator from "./PagingIndicator";

export default PagingIndicator;
